import React from 'react'
import { bindActionCreators, compose } from 'redux'
import { connect } from 'react-redux'
import styled from 'styled-components'
import windowDimensions from 'react-window-dimensions'

import {
  playerStop,
  toggleOffsetView
} from '../../duck/operations'

import Image from '../shared/image'
import { Button } from '../shared/button'
import { ProgressBar } from './utils/progressBar'
import { Timer as BaseTimer } from './utils/timer'

import { device } from '../../lib/deviceSizes'

import DisconnectSvg from '../../assets/icons/disconnect.svg'
import ResyncSvg from '../../assets/icons/resync.svg'

const Main = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;

  width: 100%;
  max-width: 900px;
  margin-top: 24px;
  margin-right: 20px;
`

const ProgressBarContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  height: 24px;
  width: 100%;
`

const StyledTimer = styled(BaseTimer)`
  margin-top: -2px;

  font-size: 14px;
  font-family: DroidSansMono, Courier;
  letter-spacing: -1.2px;
  font-weight: 400;

  @media ${device.xSmall} {
    font-size: calc(10px + 0.5vw);
  }
`

const ElapsedTimer = styled(StyledTimer).attrs({
  dynamic: true
})`
  position: relative;
  right: 12px;
  text-align: right;
`

const TotalDuration = styled(StyledTimer).attrs({
  dynamic: false
})`
  position: relative;
  left: 12px;
`

const ButtonsContainer = styled.div`
  display: flex;
  justify-content: center;
`

const DisconnectIcon = styled(Image).attrs({
  src: DisconnectSvg,
  alt: ''
})`
  margin-right: 3px;
  width: 10px;
`

const ResyncIcon = styled(Image).attrs({
  src: ResyncSvg,
  alt: ''
})`
  margin-right: 4px;
  width: 10px;
`

// Arbitrary max sizes for the progress bar so it doesn't look ugly (too large)
const maxBarWidths = {
  small: 260,
  large: 320
}

const PlayerControlsComponent = (props) => {
  // Large screen: the bar should take 25% of the screen (with a max of maxBarWidths.large)
  // Small screen: the bar should take the full screen minus margins for the timers (with a max of maxBarWidths.small)
  const barWidth = props.width > device.small
    ? Math.min(props.width, maxBarWidths.large)
    : Math.min(props.width - 275, maxBarWidths.small)
  return (
    <Main>
      <ProgressBarContainer>
        <ElapsedTimer />
        <ProgressBar {...props} width={barWidth} height={8} />
        <TotalDuration />
      </ProgressBarContainer>
      <ButtonsContainer>
        <Button onClick={props.playerStop}>
          <DisconnectIcon />Disconnect
        </Button>
        <Button onClick={props.toggleOffsetView}>
          <ResyncIcon />Resync
        </Button>
      </ButtonsContainer>
    </Main>
  )
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators( { playerStop, toggleOffsetView }, dispatch)
}

export const PlayerControls = compose(
  connect(null, mapDispatchToProps),
  windowDimensions()
)(PlayerControlsComponent)



// WEBPACK FOOTER //
// ./src/components/player/playerControls.js